// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6652 ? "8383b485" : chunkId) + "." + {"1145":"0ccbcd0e23210042","3364":"8fa11b3fa18846a9","4646":"6528bb37e823a818","6652":"c7ae48e8ae41c577","7527":"523225f305d9c4d6"}[chunkId] + ".js";
};